import { Pipe, PipeTransform } from '@angular/core';
import { DropDownOption } from '@interfaces/form.interface';

@Pipe({
  name: 'optionSelected',
})
export class OptionSelectedPipe implements PipeTransform {
  transform(values: DropDownOption[]): DropDownOption[] {
    return values.filter((e) => e.selected);
  }
}
